// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + ({"200":"wix-i18n-config_intl-pluralrules","894":"wix-i18n-config_intl-relativetimeformat"}[chunkId] || chunkId) + ".chunk.min.js";
};